module.exports = __webpack_public_path__ + "img/check.abca1771.svg";